module.exports = __webpack_public_path__ + "img/jwcsm.b51dfeae.webp";